import(/* webpackMode: "eager", webpackExports: ["Performer"] */ "/builds/front/eva-ai-web/src/app/[locale]/(pages)/(main)/(commonInitPage)/performer.ts");
